import React from 'react';

import AccommodationsPanel from './AccommodationsPanel';
import MapPropertyPanel from './MapPropertyPanel';
import RestaurantPanel from './RestaurantPanel';
import CombinePanel from './CombinePanel';
import RoomPanel from './RoomPanel';

export interface PropertyPanelsProps {
  property: string;
}

const PropertyPanels: React.FC<PropertyPanelsProps> = ({ property }) => {


  return (
    <div className='property-panels'>
      <MapPropertyPanel property={property} />
      <RoomPanel property={property} />
      {
        property !== 'atacama' &&
        <CombinePanel property={property} main={true} />
      }
      <RestaurantPanel property={property} />
      <AccommodationsPanel property={property} />
      <CombinePanel property={property} />
    </div>
  );
};

export default PropertyPanels;